<div class="min-vh-100 py-4 d-flex align-items-md-center justify-content-center pt-10 pt-md-0">
    <div class="container">
        @if (!(loggedIn$ | async)) {
            <div class="row">
                <div class="col-12 col-md-6 pe-md-6 mb-6 mb-md-0">
                    <div class="invitation-text">
                        <app-logo class="d-block mb-6" [staticLogo]="true" />
                        <h1 class="title">{{ pageTitle || 'auth.login.page_title' | translate }}</h1>
                        <div class="subtitle mb-6">
                            <p>
                                <a [routerLink]="[routeEntity.Root, routeEntity.Register]">{{ 'auth.login.invitation_text.p2' | translate }}</a>&nbsp;{{ 'auth.login.invitation_text.p3' | translate }}
                            </p>
                        </div>
                        <app-store-links class="d-none d-md-block"></app-store-links>
                    </div>
                </div>

                <div class="col-12 col-md-6 ps-md-6">
                    <app-login-form [settings]="settings$ | async"
                                    [pending]="pending$ | async"
                                    [error]="error$ | async"
                                    [countryCodes]="countryCodes$ | async"
                                    [defaultCode]="defaultCode$ | async"
                                    (signInByPhone)="signInByPhone($event)"
                                    (signInByGoogle)="signInByGoogle()"
                                    (signInByEmail)="signInByEmail($event)" />
                </div>
            </div>
        }
    </div>
</div>
